const initialStateBase = {
    isFetching: false,
    isError: false,
    widgets: null
};

export const TYPE = 'CATEGORIES_WIDGET';

export const urls = {
    getCategoryWidgets: id => `/api/config/category-${id}`
};

export default (state = initialStateBase, action) => {
    let data = {};
    let sortedWidgets = [];

    switch (action.type) {
        case `REQUEST_${TYPE}`:
            return {
                ...state,
                isFetching: true
            };
        case `RECEIVE_${TYPE}`:
            data = action?.data?.data || {};
            sortedWidgets = (data.widgets || []).sort((a, b) => a.order - b.order);

            return {
                ...state,
                isFetching: false,
                isError: false,
                widgets: {
                    ...state.widgets,
                    [data.categoryId]: sortedWidgets
                }
            };
        case `ERROR_${TYPE}`:
            return {
                isFetching: false,
                isError: true,
                widgets: null
            };
        default:
            return state;
    }
};
